import React, { useEffect, useRef } from "react";

const HmeTopWinner = ({ speed = 20 }) => {
  const sliderRef = useRef(null);
  useEffect(() => {
    const slider = sliderRef.current;
    let scrollAmount = 0;

    function scrollHeadlines() {
      if (slider) {
        scrollAmount += 1;
        if (scrollAmount >= slider.scrollWidth / 2) {
          scrollAmount = 0;
        }
        slider.style.transform = `translateX(-${scrollAmount}px)`;
      }
    }
    const interval = setInterval(scrollHeadlines, speed);
    return () => clearInterval(interval);
  }, [speed]);



  return (
    <div className="headline-slider top-winner">
      <div className="headlines-list">
      <div className="headlines" ref={sliderRef}>
          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>
          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>          <div className="top-winner-box">
            <div className="user-img">
            <img data-v-e4caeaf8="" src="https://wver.sprintstaticdata.com/v113/static/front/img/user-icon.png" alt="user-icon" />
            </div>
            <div className="plyer-detail">
              <div className="player-item"> <strong>Player</strong> <span>Z2****</span> </div>
              <div className="player-item"> <strong>Time</strong> <span>11/03/2025 00:00</span> </div>
              <div className="player-item"> <strong>Win Amount</strong> <span>25,87,500</span> </div>
            </div>
          </div>
      </div>
      </div>
    </div>
  );
};

export default HmeTopWinner;
